import config from "@/config";
import { BaseResponse, Dictionary } from "@/types/base";
import Axios from "@/utils/Axios";

export const postCutoutImageUrl = (url: any, params?: any) => {
  // const formData = new FormData();
  // formData.append('ur', url);
  return Axios.post("/user_file/url_cutout", { url }, {}, config.baseURL);
};

// 抠图结果轮训
export const getJobResult = (data: { jobId: string }) => {
  return Axios.get("/user_file/job_Hdresult", data, {}, config.baseURL);
};

export type PostBatchCutoutImageResponse = BaseResponse<{
  job_ids: Dictionary<string>;
  job_result: Dictionary<{
    job_id: string;
    reason: string;
    success: boolean;
  }>;
}>;
export const postBatchCutoutImage = (images: string[]) => {
  return Axios.post<{ images: string[] }, PostBatchCutoutImageResponse>(
    "/hd_cut_out_image",
    { images },
    {},
    config.creatorUrl,
  );
};

export type GetBatchCutoutImageResponse = BaseResponse<{
  images: Dictionary<string>;
  image_result: Dictionary<{
    image_url: string;
    job_id: string;
    reason: string;
    success: boolean;
  }>;
}>;
export const getBatchCutoutJobResult = (job_ids: string[]) => {
  return Axios.post<{ job_ids: string[] }, GetBatchCutoutImageResponse>(
    "/async_job_result",
    { job_ids },
    {},
    config.creatorUrl,
  );
};
